import { useTheme, THEMES } from "@/context/ThemeContext";
import { Palette, Check } from "lucide-react";

export default function ThemeSwitcher({ compact = false }) {
  const { themeId, setThemeId } = useTheme();
  const list = Object.values(THEMES);
  return (
    <div className="border border-[color:var(--border-line,#262626)] bg-[color:var(--bg-surface,#121212)]" data-testid="theme-switcher">
      <div className="px-4 py-3 border-b border-[color:var(--border-line,#262626)] flex items-center gap-2">
        <Palette size={16} className="text-[color:var(--accent,#FF5A1F)]" />
        <span className="font-display text-base font-black tracking-tight">Theme</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[color:var(--border-line,#262626)]">
        {list.map((t) => {
          const active = t.id === themeId;
          return (
            <button
              key={t.id}
              onClick={() => setThemeId(t.id)}
              className="text-left bg-[color:var(--bg-surface,#121212)] p-3 hover:bg-[color:var(--bg-elevated,#1A1A1A)] transition-colors relative"
              data-testid={`theme-option-${t.id}`}
            >
              <div className="flex items-center gap-2">
                <div className="flex -space-x-1">
                  <span className="w-4 h-4 rounded-full border border-white/10" style={{ background: t.vars["--bg-base"] }} />
                  <span className="w-4 h-4 rounded-full border border-white/10" style={{ background: t.vars["--accent"] }} />
                  <span className="w-4 h-4 rounded-full border border-white/10" style={{ background: t.vars["--text-primary"] }} />
                </div>
                {active && <Check size={14} className="text-[color:var(--accent,#FF5A1F)] ml-auto" />}
              </div>
              <div className="mt-2 font-semibold text-sm">{t.name}</div>
              {!compact && <div className="text-xs text-[color:var(--text-tertiary,#737373)]">{t.hint}</div>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
